import { initializeApp } from 'firebase/app';
import { ReCaptchaEnterpriseProvider, initializeAppCheck } from 'firebase/app-check';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { environment } from '../../environments/environment';

export const app = initializeApp(environment.firebase);

if (environment.appCheckSiteKey && typeof document !== 'undefined') {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(environment.appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    console.warn('App Check unavailable', err);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

const emulators = environment.emulators;
if (emulators) {
  connectAuthEmulator(auth, emulators.auth, { disableWarnings: true });
  connectFirestoreEmulator(db, emulators.firestore.host, emulators.firestore.port);
  connectFunctionsEmulator(functions, emulators.functions.host, emulators.functions.port);
}
